// Only business fields belong in the cashier view. Upstream responses and
// transport errors stay in the API response for diagnostics.
const FIELDS = {
    disability: [
        ['fullName', 'Full name'], ['birthOn', 'Date of birth'],
        ['disabilityGroup', 'Disability group'], ['disabilityReason', 'Disability reason'],
        ['tiekOrganization', 'Organization'], ['startOn', 'Valid from'], ['endOn', 'Valid until'],
    ],
    elderly: [
        ['fullName', 'Full name'], ['elderlyCategory', 'Privilege category'],
        ['birthOn', 'Date of birth'], ['disabilityGroup', 'Disability group'],
        ['organizationName', 'Organization'], ['eldOrganization', 'Organization'],
        ['startOn', 'Valid from'], ['endOn', 'Valid until'],
    ],
    student: [
        ['education_type_name', 'Education type'], ['institution', 'Organization'],
        ['education_form', 'Education form'], ['education_status', 'Education status'],
        ['course', 'Course'], ['speciality', 'Speciality'],
        ['education_start_year', 'Start year'],
    ],
    registry: [
        ['fullName', 'Full name'], ['survey_id', 'Survey ID'],
        ['poverty_level_id', 'Poverty level'], ['action', 'Registry status'],
        ['startOn', 'Valid from'], ['endOn', 'Valid until'],
    ],
    social: [
        ['fullName', 'Full name'], ['categoryName', 'Privilege category'],
        ['povertyLevel', 'Poverty level'], ['startDate', 'Valid from'],
        ['endDate', 'Valid until'],
    ],
    entitlement: [
        ['fullname', 'Full name'], ['birthdate', 'Date of birth'],
        ['eligibleCode', 'Privilege code'], ['eligibleType', 'Privilege category'],
        ['discountPercent', 'Discount percent'], ['discountTripsPerYear', 'Trips per year'],
        ['discountNote', 'Discount note'],
        ['privilegeUse', 'Privilege used'], ['transport_type', 'Transport type'],
        ['ticket_issued_date', 'Ticket issue date'], ['route_type', 'Route type'],
        ['ticket_series_number', 'Ticket series and number'],
        ['full_fare_amount', 'Full fare amount'], ['subsidy_amount', 'Subsidy amount'],
        ['paid_amount', 'Paid amount'],
    ],
};

function object(value) {
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function firstValue(source, keys) {
    for (let i = 0; i < keys.length; i++) {
        const value = source[keys[i]];
        if (value !== undefined && value !== null && value !== '' && typeof value !== 'object') return value;
    }
    return null;
}

function person(source) {
    const name = [source.lastName, source.firstName, source.middleName].filter(Boolean).join(' ');
    return Object.assign({}, source, { fullName: firstValue(source, ['fullName', 'fullname', 'full_name']) || name });
}

function fields(source, definitions) {
    const seen = {};
    return definitions.reduce((out, definition) => {
        const key = definition[0];
        const label = definition[1];
        const value = firstValue(source, [key]);
        if (value === null || seen[label]) return out;
        seen[label] = true;
        out.push({ label, value: typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value) });
        return out;
    }, []);
}

function addGroup(groups, source, definitions, title = null, index = null) {
    const selected = fields(person(object(source)), definitions);
    if (selected.length) groups.push({ title, index, fields: selected });
}

function payload(result) {
    const raw = object(result.data);
    return raw.data && typeof raw.data === 'object' && !Array.isArray(raw.data)
        ? raw.data
        : raw;
}

export function privilegeResultGroups(result) {
    if (!['found', 'received', 'partial'].includes(result.status)) return [];
    const data = payload(result);
    const groups = [];
    switch (result.key) {
    case 'chernobyl_radiation_illness':
    case 'nuclear_radiation_veteran':
        addGroup(groups, object(object(data.service_response).data), FIELDS.disability);
        break;
    case 'elderly_disabled_needing_care':
        (Array.isArray(data.rows) ? data.rows : []).forEach((row, index) => {
            addGroup(groups, row, FIELDS.elderly, 'Record', index + 1);
        });
        break;
    case 'accompanying_person':
        (Array.isArray(data.ward_checks) ? data.ward_checks : []).forEach((item, index) => {
            if (item.eligible === true) addGroup(groups, item.ward, FIELDS.elderly, 'Record', index + 1);
        });
        break;
    case 'students':
        addGroup(groups, data, FIELDS.student);
        break;
    case 'disabled_youth_vocational_training':
        if (object(object(data.services).vtek_passport).received === true) {
            addGroup(groups, object(object(object(data.services).vtek_passport).response).data, FIELDS.disability);
        }
        break;
    case 'social_registry_youth_competition':
        addGroup(groups, Object.assign({}, object(data.registry_data), data), FIELDS.registry);
        break;
    case 'social_protection':
        addGroup(groups, data, FIELDS.social);
        break;
    case 'world_war_ii_participants':
        addGroup(groups, Object.assign({}, data, {
            discountPercent: result.discountPercent,
            discountTripsPerYear: result.discountTripsPerYear,
            discountNote: result.discountNote,
        }), FIELDS.entitlement);
        break;
    }
    return groups;
}
